import VideoPlayer from "../../../views/digibord/content/VideoPlayer.vue";

export default function createVideoPlayerRoute(name) {
  return [
    {
      path: "video/:videoSlug?/",
      name,
      component: VideoPlayer,
      meta: {
        containerClass: "showVideoPlayer",
      },
    },
  ];
}
